export default "__VITE_ASSET__IVjhiD1b__"